import I18n from 'I18n';
import isMacOs from 'automation-ui-canvas/components/flow-header/menu-bar/utils/isMacOs';
export function formatShortcut(shortcut) {
  if (isMacOs()) {
    return formatShortcutForMacOS(shortcut);
  } else {
    return formatShortcutForWindows(shortcut);
  }
}
export function formatShortcutForWindows(shortcut) {
  const parts = [];
  if (shortcut.control) {
    parts.push({
      type: 'key',
      value: I18n.text('automation.editorMenuBar.shortcuts.controlAbbreviation')
    }, {
      type: 'text',
      value: ' + '
    });
  }
  if (shortcut.option) {
    parts.push({
      type: 'key',
      value: I18n.text('automation.editorMenuBar.shortcuts.altAbbreviation')
    }, {
      type: 'text',
      value: ' + '
    });
  }
  if (shortcut.shift) {
    parts.push({
      type: 'key',
      value: I18n.text('automation.editorMenuBar.shortcuts.shiftAbbreviation')
    }, {
      type: 'text',
      value: ' + '
    });
  }
  parts.push({
    type: 'key',
    value: shortcut.key
  });
  return parts;
}
export function formatShortcutForMacOS(shortcut) {
  const parts = [];
  if (shortcut.option) {
    parts.push({
      type: 'key',
      value: '⌥',
      tooltip: I18n.text('automation.editorMenuBar.shortcuts.optionAbbreviation')
    });
  }
  if (shortcut.shift) {
    parts.push({
      type: 'key',
      value: '⇧',
      tooltip: I18n.text('automation.editorMenuBar.shortcuts.shiftAbbreviation')
    });
  }
  if (shortcut.control) {
    parts.push({
      type: 'key',
      value: '⌘',
      tooltip: I18n.text('automation.editorMenuBar.shortcuts.commandAbbreviation')
    });
  }
  parts.push({
    type: 'key',
    value: shortcut.key
  });
  return parts;
}